<template>
  <div>
    <img class="report_banner" :src="banner" alt="report banner" />
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'BannerNodeDisplay',
  props: {
    value: PigeonDocNodeModel,
    isICCS: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    banner() {
      if (this.isICCS) {
        return '/../../assets/reportHeader__ICCS.png';
      }
      return '/../../assets/reportHeader__default.png';
    },
  },
};
</script>

<style>
/* background-image: url('../../assets/reportHeader__ICCS.png');
  background-position: top left;
  background-repeat: no-repeat;
  background-size: 100%; */
.report_banner {
  width: 100%;
  height: auto;
}
</style>
